import { Twitter, Link2, Share2 } from "lucide-react";
import { WhatsAppIcon } from "@/components/social";
import { toast } from "sonner";

export const ShareButtons = ({ url, title = "", className = "" }) => {
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const enc = encodeURIComponent(shareUrl);
  const encTitle = encodeURIComponent(title);

  const targets = {
    whatsapp: `https://wa.me/?text=${encTitle}%20${enc}`,
    twitter: `https://twitter.com/intent/tweet?url=${enc}&text=${encTitle}`,
  };

  const open = (href) => window.open(href, "_blank", "noopener,noreferrer,width=600,height=500");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success("Link copied to clipboard");
    } catch {
      toast.error("Could not copy the link");
    }
  };

  const nativeShare = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url: shareUrl }); } catch { /* user cancelled */ }
    } else {
      copy();
    }
  };

  const Btn = ({ onClick, label, testid, children }) => (
    <button
      type="button"
      aria-label={label}
      data-testid={testid}
      onClick={onClick}
      className="flex h-9 w-9 items-center justify-center rounded-full bg-muted text-muted-foreground transition-colors hover:bg-primary hover:text-primary-foreground"
    >
      {children}
    </button>
  );

  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="share-buttons">
      <span className="text-sm font-semibold mr-1">Share:</span>
      <Btn onClick={() => open(targets.whatsapp)} label="Share on WhatsApp" testid="share-whatsapp"><WhatsAppIcon className="w-4 h-4" /></Btn>
      <Btn onClick={() => open(targets.twitter)} label="Share on X" testid="share-twitter"><Twitter className="w-4 h-4" /></Btn>
      <Btn onClick={copy} label="Copy link" testid="share-copy"><Link2 className="w-4 h-4" /></Btn>
      <Btn onClick={nativeShare} label="More sharing options" testid="share-native"><Share2 className="w-4 h-4" /></Btn>
    </div>
  );
};
